module.exports = __webpack_public_path__ + "img/multidays.a4f93958.png";